import { render } from "./ActionsDropdown.vue?vue&type=template&id=324d716c"
import script from "./ActionsDropdown.vue?vue&type=script&lang=js"
export * from "./ActionsDropdown.vue?vue&type=script&lang=js"

import "./ActionsDropdown.vue?vue&type=style&index=0&id=324d716c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__